export default "<a  (click)=\"onClick()\"   href=\"javascript:void(0)\" class=\"link\"> {{this.rowData.customerNumber}}</a>\n"